import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction } from '@/api/manage';
export default {
  name: 'SelectProductListModal',
  data: function data() {
    return {
      title: '选择产品',
      queryParam: {},
      columns: [{
        title: '产品编号',
        align: 'center',
        dataIndex: 'code',
        fixed: 'left',
        width: 200
      }, {
        title: '产品名称',
        align: 'center',
        dataIndex: 'name'
      }, {
        title: '规格型号',
        align: 'center',
        dataIndex: 'model'
      }, {
        title: '产品类别',
        align: 'center',
        dataIndex: 'category_dictText'
      }, {
        title: '生产商',
        align: 'center',
        dataIndex: 'companyName'
      }, {
        title: '产品状态',
        align: 'center',
        dataIndex: 'status_dictText'
      }],
      dataSource: [],
      companyList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      category: '',
      url: {
        queryCompany: '/ea/company/info/queryCompanyName'
      }
    };
  },
  created: function created() {},
  methods: {
    add: function add(selectUser, userIds) {
      this.visible = true;
      this.edit(selectUser, userIds);
    },
    edit: function edit(selectUser, userIds) {
      this.loadCompany();
      this.loadData();

      if (!userIds) {
        this.selectedRowKeys = [];
      } else {
        this.selectedRowKeys[0] = userIds;
      }

      if (!selectUser) {
        this.selectionRows = [];
      } else {
        this.selectionRows = selectUser;
      }
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    loadData: function loadData(arg) {
      var _this = this;

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      var url = '/ea/product/info?status=1&category=' + this.category;

      if (this.category == 21 || this.category == 22 || this.category == 23) {
        url = '/ea/product/chemical?status=1&category=' + this.category;
      }

      if (this.danger && this.danger == 1) {
        url = '/ea/product/chemical?status=1&danger=' + this.danger;
      }

      getAction(url, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    handleSelect: function handleSelect() {
      if (this.selectionRows.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }

      this.$emit('selectProduct', this.selectionRows);
      this.handleCancel();
    },
    close: function close() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    }
  }
};